import { useEffect, useState } from "react";
import { ReclasificacionApi } from "../api/ReclasificacionApi";
import { getErrorFromResponse } from "../../../../../../../../../utility/utils";
import { NotificationManager } from "react-notifications";

const indexarPorId = (inventarios) => {
    const indice = {};

    (inventarios || []).forEach((inventario) => {
        indice[inventario.id] = inventario;
    });

    return indice;
};

// La selección se guarda aparte de la página cargada, indexada por id, para que
// cambiar de página no borre lo que ya se había elegido en las anteriores.
export const useReclasificacion = ({
    opened,
    onClose,
    inventariosReclasificacion,
    setInventariosReclasificacion,
    productoId,
    refreshKey,
    reclasificacionPendiente,
}) => {
    const { getInventariosReclasificacion, cargando } = ReclasificacionApi();

    const [paginaSeleccionada, setPaginaSeleccionada] = useState(1);
    const [cantidadResultados, setCantidadResultados] = useState(0);

    // inventarios de la página que se está viendo
    const [inventariosPagina, setInventariosPagina] = useState([]);

    // pacas elegidas en todas las páginas, por id de inventario
    const [seleccion, setSeleccion] = useState({});

    const GetInventariosReclasificacion = async () => {
        if (!productoId || !reclasificacionPendiente) {
            setInventariosPagina([]);
            setCantidadResultados(0);
            return;
        }

        try {
            const params = {
                page: paginaSeleccionada,
                producto_id: productoId,
                filtrar_disponibles: true,
            };

            const response = await getInventariosReclasificacion(params);
            setInventariosPagina(response.results);
            setCantidadResultados(response.count);
        } catch (error) {
            // Si el error es por una página inválida, volvemos a la página anterior
            if (
                error &&
                error.detail === "Invalid page." &&
                paginaSeleccionada > 1
            ) {
                setPaginaSeleccionada((prev) => prev - 1);
                return;
            }

            const errorMsg = getErrorFromResponse(
                error,
                "Error al obtener inventarios reclasificacion",
            );
            NotificationManager.error(errorMsg, "Error", 3000);

            setInventariosPagina([]);
            setCantidadResultados(0);
        }
    };

    // al cambiar de producto la selección deja de ser válida
    useEffect(() => {
        setSeleccion({});
        setInventariosReclasificacion([]);
    }, [productoId]);

    useEffect(() => {
        setPaginaSeleccionada(1);
    }, [productoId, reclasificacionPendiente]);

    useEffect(() => {
        GetInventariosReclasificacion();
    }, [paginaSeleccionada, refreshKey, productoId]);

    // al abrir se parte de lo que ya estaba guardado, así se descarta cualquier
    // cambio que haya quedado de una vez anterior
    useEffect(() => {
        if (opened) {
            setSeleccion(indexarPorId(inventariosReclasificacion));
        }
    }, [opened]);

    // la página se muestra con las pacas que ya tenga elegidas cada inventario
    const draftInventarios = inventariosPagina.map((inventario) => {
        const seleccionado = seleccion[inventario.id];

        return {
            ...inventario,
            pacas_a_consumir: seleccionado
                ? seleccionado.pacas_a_consumir
                : undefined,
        };
    });

    const handleChange = (inventarioId, field, value) => {
        const inventario = inventariosPagina.find(
            (item) => item.id === inventarioId,
        );

        if (!inventario) return;

        setSeleccion((prev) => ({
            ...prev,
            [inventarioId]: {
                ...(prev[inventarioId] || inventario),
                [field]: value,
                _dirty: true,
            },
        }));
    };

    const handleSave = () => {
        const seleccionados = Object.keys(seleccion)
            .map((inventarioId) => seleccion[inventarioId])
            .filter(
                (inventario) =>
                    inventario.pacas_a_consumir &&
                    parseInt(inventario.pacas_a_consumir) > 0,
            );

        setInventariosReclasificacion(seleccionados);
        onClose();
    };

    const handleClose = () => {
        // Si hay cambios sin guardar, descartarlos y cerrar
        setSeleccion(indexarPorId(inventariosReclasificacion));
        onClose();
    };

    return {
        cargando,

        paginaSeleccionada,
        setPaginaSeleccionada,

        cantidadResultados,

        draftInventarios,

        handleChange,
        handleSave,
        handleClose,
    };
};
